












/** 顯示車輛保險配備的卡 */

import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { Description } from '@/composables/use-car-descriptions'

export default defineComponent({
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String as PropType<'xs' | 'md'>,
      default: 'xs',
    },
    skeleton: {
      type: Boolean,
      default: false,
    },
  },
  setup () {
    const getLabelClass = (item: Description) => ({
      [item.status ?? 'default']: true,
    })

    return {
      getLabelClass,
    }
  },
})
